<template>
  <div class="sheet modal-page" :class="{ active: ready }">
    <div class="sheet-content">
      <slot />
      <div class="row row-action">
        <div class="col-12 px-2">
          <button
            type="button"
            class="btn btn-primary btn-lg btn-block"
            @click="$emit('submit')"
          >
            ตกลง
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertSheet",

  data() {
    return {
      ready: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.ready = true;
    }, 450);
  },
};
</script>

<style lang="scss" scoped>
.sheet-content {
  width: 100%;
  bottom: 0px;
  height: 315px;
  padding: 15px;
  position: fixed;
  border-radius: 1px;
  background-color: #ffffff;

  .row-action {
    width: 100%;
    bottom: 36px;
    padding: 0px 12px;
    position: absolute;
  }
}
</style>
